<template>
  <v-row no-gutters>
    <v-col cols="12" class="pb-3">
      <div class="text-truncate flex-shrink-1 text-body-1 font-weight-medium">
        {{ currentTimestepFormatted }}
      </div>
    </v-col>
    <v-col cols="12">
      <v-row no-gutters class="justify-space-between">
        <v-col cols="auto" class="ml-n1 text-body-2 font-weight-medium">
          1
        </v-col>
        <v-col cols="auto" class="mr-n1 text-body-2 font-weight-medium">
          {{ timestepsLength }}
        </v-col>
      </v-row>
    </v-col>
    <v-col cols="12" class="pb-2">
      <v-slider
        :style="thumbColor"
        thumb-color="white"
        :value="value"
        @change="$emit('input', $event)"
        ticks
        :max="lastTimestepIndex"
        hide-details
        @start="$emit('start')"
      >
      </v-slider>
    </v-col>
    <v-col cols="12">
      <base-rounded-button
        icon="mdi-skip-previous"
        outlined
        icon-color="primary"
        color="#DFDFDF"
        size="x-small"
        :tooltip="$i18n.t('button.previousTimestep')"
        @click="onSkipPressed(false)"
      >
      </base-rounded-button>
      <base-rounded-button
        v-if="hasPlayButton"
        v-bind="playPauseButtonConfig"
        outlined
        icon-color="primary"
        color="#DFDFDF"
        size="x-small"
        @click="playPauseAction"
      >
      </base-rounded-button>
      <base-rounded-button
        icon="mdi-skip-next"
        outlined
        icon-color="primary"
        color="#DFDFDF"
        size="x-small"
        :tooltip="$i18n.t('button.nextTimestep')"
        @click="onSkipPressed(true)"
      >
      </base-rounded-button>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'ModelingResulstsLayer',
  props: {
    value: {
      type: Number,
      required: true,
    },
    timesteps: {
      type: Array,
      required: true,
    },
    hasPlayButton: {
      type: Boolean,
      default: true,
    },
    interval: {
      type: Number,
      default: 1000,
    },
  },
  data: () => ({
    isAnimationPlaying: false,
  }),
  computed: {
    currentTimestepFormatted() {
      return this.$dayjs(this.currentTimestep).format('LL, LT');
    },
    currentTimestep() {
      return this.timesteps[this.value];
    },
    thumbColor() {
      return {
        '--thumb-color': this.$_colors.primary,
      };
    },
    timestepsLength() {
      return this.timesteps.length;
    },
    lastTimestepIndex() {
      return this.timestepsLength - 1;
    },
    playPauseButtonConfig() {
      return this.isAnimationPlaying
        ? {
            icon: 'mdi-play-pause',
            tooltip: this.$i18n.t('button.pauseModelingAnimation'),
          }
        : {
            icon: 'mdi-play',
            tooltip: this.$i18n.t('button.playModelingAnimation'),
          };
    },
    playPauseAction() {
      return this.isAnimationPlaying ? this.pauseAnimation : this.playAnimation;
    },
  },
  methods: {
    playAnimation() {
      this.isAnimationPlaying = true;
      const play = () => {
        this.$emit('input', this.value + 1);
        this.currentTimeout = setTimeout(() => {
          play();
        }, this.interval);
      };
      play();
    },
    onSkipPressed(isNext) {
      this.pauseAnimation();
      const value = isNext ? this.value + 1 : this.value - 1;
      this.$emit('input', value);
    },
    pauseAnimation() {
      clearTimeout(this.currentTimeout);
      this.isAnimationPlaying = false;
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep {
  .v-slider--horizontal {
    margin: 0px;
    .v-slider__thumb {
      border: 2px solid var(--thumb-color) !important;
    }
  }
}
</style>
